import React, { useState, useRef, Fragment, useContext } from "react";
//Imported Packages
import moment from "moment";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
//Icons
import { CheckCircleIcon } from "@heroicons/react/20/solid";
import { ArrowUpOnSquareIcon } from "@heroicons/react/24/outline";
import { IoAddCircleSharp } from "react-icons/io5";
import { HiOutlineInformationCircle } from "react-icons/hi";

import eth from "../../media/eth.png";
//import eth from "../../node_modules/cryptocurrency-icons/svg/icon/eth.svg";

//Components
import { Accordion, Tooltip } from "flowbite-react";
import TextField from "@mui/material/TextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Toggle from "../Toggle/Toggle";
import Input from "../Input/Input";
import Dropdown from "../Dropdown/Dropdown";

const EditListing = () => {
  const [value, setValue] = useState(moment());
  const [showEndingPrice, setShowEndingPrice] = useState(false);
  const [listingType, setListingType] = useState("auction");

  let activeAccordion;
  switch (listingType) {
    case "auction":
      activeAccordion = (
        <Accordion alwaysOpen={true} arrowIcon={IoAddCircleSharp} size="lg">
          <Accordion.Panel>
            <Accordion.Title>Auction</Accordion.Title>
            <Accordion.Content>
              <h3 className=" text-lg font-bold text-black container">
                Enter Starting Price
              </h3>
              <div className="w-11/12 h-14 inline-flex shadow-sm mt-2 justify-evenly rounded-xl container mx-auto">
                <Dropdown className={`ml-10` + ` w-18`} isTime={false} />
                <Input
                  type="text"
                  name="token-price"
                  id="token-price"
                  placeholder="12 ETH"
                  disabled={false}
                  price={true}
                  usd={false}
                  className={`w-48` + `h-14` + ` ml-12`}
                />
                <Input
                  type="text"
                  name="token-price-usd"
                  id="token-price-usd"
                  placeholder="{$425.64}"
                  disabled={false}
                  price={true}
                  usd={true}
                  className={`w-48` + `h-14` + ` ml-16`}
                />
              </div>
              <div className="mt-8 inline-flex">
                <h4 className=" text-sm font-semibold text-black container">
                  Include Ending Price
                </h4>
                <div className="ml-96">
                  <Toggle
                    initialToggleState={false}
                    onToggle={(val) => {
                      setShowEndingPrice(val);
                      console.log(`toggle switched to ${val}!`);
                    }}
                  />
                </div>
              </div>
              <div
                className="mt-4"
                style={showEndingPrice ? null : { display: "none" }}
              >
                <h3 className=" text-lg font-bold text-black container">
                  Enter Ending Price
                </h3>
                <div className="w-11/12 h-14 inline-flex shadow-sm mt-2 justify-evenly rounded-xl container mx-auto">
                  <Dropdown className={`ml-10` + ` w-18`} isTime={false} />
                  <Input
                    type="text"
                    name="token-price"
                    id="token-price"
                    placeholder="12 ETH"
                    disabled={false}
                    price={true}
                    usd={false}
                    className={`w-48` + `h-14` + ` ml-12`}
                  />
                  <Input
                    type="text"
                    name="token-price-usd"
                    id="token-price-usd"
                    placeholder="{$425.64}"
                    disabled={false}
                    price={true}
                    usd={true}
                    className={`w-48` + `h-14` + ` ml-16`}
                  />
                </div>
              </div>
            </Accordion.Content>
          </Accordion.Panel>
        </Accordion>
      );
      break;
    case "fixed":
      activeAccordion = (
        <Accordion alwaysOpen={true} arrowIcon={IoAddCircleSharp} size="lg">
          <Accordion.Panel>
            <Accordion.Title>Fixed Price</Accordion.Title>
            <Accordion.Content>
              <h3 className=" text-lg font-bold text-black container">
                Enter Price
              </h3>
              <div className="w-11/12 h-14 inline-flex shadow-sm mt-2 justify-evenly rounded-xl container mx-auto">
                <Dropdown className={`ml-10` + ` w-18`} isTime={false} />
                <Input
                  type="text"
                  name="token-price"
                  id="token-price"
                  placeholder="12 ETH"
                  disabled={false}
                  price={true}
                  usd={false}
                  className={`w-48` + `h-14` + ` ml-12`}
                />
                <Input
                  type="text"
                  name="token-price-usd"
                  id="token-price-usd"
                  placeholder="{$425.64}"
                  disabled={false}
                  price={true}
                  usd={true}
                  className={`w-48` + `h-14` + ` ml-16`}
                />
              </div>

              <div className="">
                <div className="mt-8">
                  <h3 className=" text-lg font-bold text-black container">
                    Set Expiration
                  </h3>
                  <h4 className=" block mt-2  text-sm font-medium text-black container">
                    Your listing will automatically end on
                  </h4>
                  <div className="mt-6 flex flex-row place-content-start ">
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DatePicker
                        label="Set Date"
                        value={value}
                        onChange={(newValue) => {
                          setValue(newValue);
                        }}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                    <h5 className=" ml-12 mt-2 text-2xl font-bold">At</h5>
                    <div className="flex">
                      <input
                        type="text"
                        className="w-36 h-11 ml-10 shadow-md rounded-xl place-content-center place-items-center"
                        value={moment().format("h:mm a")}
                        disabled
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Accordion.Content>
          </Accordion.Panel>
        </Accordion>
      );
      break;
    case "rent":
      activeAccordion = (
        <Accordion>
          <Accordion.Panel>
            <Accordion.Title>Rental</Accordion.Title>
            <Accordion.Content>
              <div className="ml-10">
                <div className="image-placeholder w-52 h-28 mb-6 relative right-12 rounded-lg bg-slate-100 flex flex-col">
                  <ArrowUpOnSquareIcon className="p-8" />
                  <h5 className=" relative flex place-content-center place-items-center bottom-6 text-sm text-slate-500 font-bold">
                    Property Image
                  </h5>
                </div>
                <div className="mt-4 relative right-10">
                  <h3 className=" text-sm font-bold text-slate-400">
                    Rental Price
                  </h3>
                </div>
                <div className="w-full h-14 inline-flex relative right-6 shadow-sm mt-2 justify-evenly rounded-xl container mx-auto">
                  <Dropdown className={`w-18`} isTime={false} />
                  <Input
                    type="text"
                    name="token-price"
                    id="token-price"
                    placeholder="12 ETH"
                    disabled={false}
                    price={true}
                    usd={false}
                    className={`w-48` + `h-14` + ` ml-12`}
                  />
                  <Input
                    type="text"
                    name="token-price-usd"
                    id="token-price-usd"
                    placeholder="{$425.64}"
                    disabled={false}
                    price={true}
                    usd={true}
                    className={`w-48` + `h-14` + ` ml-16`}
                  />
                </div>
                <div className="w-3/4 h-12 mt-12 relative right-10 flex flex-row flex-nowrap bg-white border-2 border-solid border-slate-300 rounded-xl divide-x-2">
                  <Dropdown isTime={true} frequency="0" />
                  <Dropdown className="w-48 " isTime={true} frequency="Days" />
                </div>
              </div>
            </Accordion.Content>
          </Accordion.Panel>
        </Accordion>
      );
  }

  return <>{activeAccordion}</>;
};
export default EditListing;
